/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SyokuziteateService from "../../../service/master/syokuziteate/syokuziteateService"
import {
  TSyokuziteateListGetReq,
  TSyokuziteateListGetRes,
} from "../../../service/master/syokuziteate/TSyokuziteate"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { 区分分類コード } from "../../../constant/enum/codes"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import KubunService from "../../../service/master/kubun/kubunService"
import { T市区町村 } from "../../../service/master/sikutyoson/TSikutyoson"
import ComboBox from "../../../components/ComboBox"
import TodohukenService from "../../../service/master/todohuken/todohukenService"
import { T都道府県 } from "../../../service/master/todohuken/TTodohuken"

//#region [type]
export type T食事手当入力Item = TSyokuziteateListGetRes &
  Partial<{
    行ID: symbol
  }>
//#endregion

/**
 * 食事手当マスタ
 * @returns
 */
const MasterSyokuziteateRegister = () => {
  const history = useHistory()
  const location = useLocation()

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "MasterSyokuziteateRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T食事手当入力Item>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {},

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyokuziteateListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    let currentSearchCondition: TSyokuziteateListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyokuziteateService().getList(
        currentSearchCondition
      )
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyokuziteateListGetReq = queryString.parse(location.search)
    set都道府県コード(query.都道府県コード ?? "")
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyokuziteateListGetReq => {
    return {
      都道府県コード: 都道府県コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyokuziteateListGetReq
  ) => {
    return {
      都道府県: 都道府県ItemsSource?.find(
        (i) => i.団体コード === searchCondition.都道府県コード
      )?.都道府県名漢字,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set都道府県コード("")
    setIsSubmitButton(false)
    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    // AddNew行を除いてデータ行がある場合に登録ボタン制御
    if (f.rows.length > 1) {
      setIsSubmitButton(true)
    } else {
      setIsSubmitButton(false)
    }

    // buttonControl()
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  // TODO:PUTのみ？
  const submit = async () => {
    showInfoToast(`submitてすと`)
    setIsConfirmModalShow(false)
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // gridのリスト用DataMap
  const [積都道府県DataMap, set積都道府県DataMap] =
    useState<wjcGrid.DataMap<T市区町村>>()
  const [卸都道府県DataMap, set卸都道府県DataMap] =
    useState<wjcGrid.DataMap<T市区町村>>()
  const [食事手当区分DataMap, set食事手当区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  // state
  const [都道府県コード, set都道府県コード] = useState<string | null>("")
  // TODO:不要？
  //   const [都道府県, set都道府県] = useState<T都道府県 | null>()

  // AutoComplete
  const [都道府県ComboBox, set都道府県ComboBox] = useState<TWijmoComboBox<
    T都道府県["都道府県コード"],
    T都道府県
  > | null>(null)
  const [都道府県IsLoadEnded, set都道府県IsLoadEnded] = useState<boolean>(false)
  const [都道府県ItemsSource, set都道府県ItemsSource] = useState<T都道府県[]>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `食事手当マスタ`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  //DataMap設定
  useEffect(() => {
    Promise.all([
      new KubunService().getList(),
      new TodohukenService().getList(),
    ]).then(([区分マスタRes, 都道府県マスタRes]) => {
      set食事手当区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.マスタ.食事手当区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set積都道府県DataMap(
        new wjcGrid.DataMap(
          都道府県マスタRes.data,
          "団体コード",
          "都道府県名漢字"
        )
      )
      set卸都道府県DataMap(
        new wjcGrid.DataMap(
          都道府県マスタRes.data,
          "団体コード",
          "都道府県名漢字"
        )
      )
      set都道府県ItemsSource(都道府県マスタRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">食事手当マスタ</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-30rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="w-10rem">
                          <ComboBox.Todohuken
                            placeholder="都道府県"
                            isAllSelect={true}
                            isLoadEnded={都道府県IsLoadEnded}
                            itemsSource={都道府県ItemsSource}
                            setIsLoadEnded={set都道府県IsLoadEnded}
                            setSelectedValue={set都道府県コード}
                            selectedValue={都道府県コード}
                            ComboBox={都道府県ComboBox}
                            // setSelectedItem={set都道府県}
                            setComboBox={
                              set都道府県ComboBox
                            }></ComboBox.Todohuken>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card className="w-60rem">
            {/* <Card> */}
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                isShowGridFooter={false}
                gridProperties={{
                  newRowAtTop: true,
                }}>
                <wjrGrid.FlexGridColumn
                  binding="積都道府県コード"
                  width={120}
                  isRequired
                  dataMap={積都道府県DataMap}
                  header="積都道府県"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸都道府県コード"
                  width={120}
                  isRequired
                  dataMap={卸都道府県DataMap}
                  header="卸都道府県"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="食事手当区分コード"
                  width={120}
                  isRequired
                  dataMap={食事手当区分DataMap}
                  header="食事手当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={300}
                  header="備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
              <Row>
                <Col>
                  <div>
                    <Button
                      type="button"
                      variant={isSubmitButton ? "waiting" : "secondary"}
                      disabled={!isSubmitButton}
                      onClick={() => {
                        // TODO:登録,Validation,
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default MasterSyokuziteateRegister
